import { useEffect } from "react";
import { useUnsavedPageWarning } from "../contexts/UnsavedPageWarningContext";

/**
 * Marks the page as having unsaved changes while an inline editor is open,
 * so navigation shows a leave confirmation. Clears on save/cancel/unmount.
 */
export function useUnsavedWhileEditing(key: string, isEditing: boolean) {
  const { addUnSavePageWarning } = useUnsavedPageWarning();

  useEffect(() => {
    if (isEditing) {
      addUnSavePageWarning({
        title: "Unsaved changes warning",
        message:
          "You are still editing this AI note. If you leave now, any unsaved changes may be lost.",
        isUnsaved: [key, true],
        disableSave: true,
      });
    } else {
      addUnSavePageWarning({ isUnsaved: [key, false] });
    }

    return () => {
      addUnSavePageWarning({ isUnsaved: [key, false] });
    };
  }, [addUnSavePageWarning, isEditing, key]);
}
